/** @format */

export const utilityRemoveLocalStorage = (ref: string): void => localStorage.removeItem(ref);
